"use strict";

// Get all buttons
document.querySelectorAll('.cart_in_btn').forEach(button => {
    button.addEventListener('click', function () {
        const productIds = this.dataset.productids.split(',');
        
        // Add items individually to handle out-of-stock scenarios
        addItemsIndividually(productIds);
    });
});

async function addItemsIndividually(productIds) {
    const results = {
        success: [],
        failed: []
    };
    
    // Process each product ID individually
    for (const productId of productIds) {
        try {
            const formData = {
                items: [{
                    id: parseInt(productId, 10),
                    quantity: 1
                }]
            };
            
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            
            const data = await response.json();
            
            if (response.ok && !data.status) {
                // Successfully added
                results.success.push(productId);
                console.log('Added to cart:', productId, data);
                // GA4 add_to_cart
                if (data.items && data.items.length) {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            currency: 'JPY',
                            items: data.items.map(function(item, index) {
                                return {
                                    item_name: item.product_title || item.title,
                                    item_id: item.sku || item.handle,
                                    price: (item.final_price || item.price) / 100,
                                    item_variant: item.variant_title || '',
                                    quantity: item.quantity,
                                    index: index + 1
                                };
                            })
                        }
                    });
                }
            } else {
                // Failed to add (out of stock, etc.)
                results.failed.push({
                    id: productId,
                    message: data.message || 'Unknown error'
                });
                console.log('Failed to add:', productId, data.message);
            }
        } catch (error) {
            console.error('Error adding product:', productId, error);
            results.failed.push({
                id: productId,
                message: 'Network error'
            });
        }
    }
    
    // Handle results
    handleAddToCartResults(results);
}

function handleAddToCartResults(results) {
    const totalAttempted = results.success.length + results.failed.length;
    const successCount = results.success.length;
    const failedCount = results.failed.length;
    
    if (successCount > 0) {
        // Update cart count for successfully added items
        updateCartCountBubble(successCount);
    }
    
    // Show appropriate toast message
    if (failedCount === 0) {
        // All items added successfully
        showCartToast(`商品を ${successCount} 点カートに追加しました`);
    } else if (successCount === 0) {
        // No items could be added
        const errorMessages = results.failed.map(item => item.message).join(', ');
        showCartToast(`Could not add items to cart: ${errorMessages}`, "#e01e5a");
    } else {
        // Mixed results - some added, some failed
        const failedMessages = results.failed.map(item => item.message).join(', ');
        showCartToast(
            `商品を ${successCount} 点カートに追加しました ${failedCount} 点 在庫がありませんでした。: ${failedMessages}`, 
            "#f39c12" // Orange color for mixed results
        );
    }
}

function updateCartCountBubble(addCount = 1) {
    const cartIcon = document.getElementById("cart-icon-bubble");
    let bubble = cartIcon.querySelector('.cart-count-bubble');
    
    if (!bubble) {
        // Create if not found
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        bubble.appendChild(span);
        cartIcon.appendChild(bubble);
    }
    
    const countSpan = bubble.querySelector('span');
    const currentCount = parseInt(countSpan.textContent) || 0;
    countSpan.textContent = currentCount + addCount;
}

function showCartToast(message = "商品をカートに追加しました", color = "#333") {
    const toast = document.getElementById("toast");
    toast.textContent = message;
    toast.classList.add("toast_on");
    toast.style.backgroundColor = color;
    
    // Fade out in 3 seconds
    setTimeout(() => {
        toast.classList.remove("toast_on");
    }, 6000);
}